<script setup lang="ts">
const checked = defineModel<boolean>({ required: true });
</script>

<template>
    <label class="checkbox">
        <input v-model="checked" type="checkbox" class="checkbox__input" />
        <span class="checkbox__mark" aria-hidden="true" />
        <span class="checkbox__text">
            <slot />
        </span>
    </label>
</template>

<style scoped>
.checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
}

.checkbox__input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
}

.checkbox__mark {
    position: relative;
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    border: 1px solid var(--custom-color-gray);
    border-radius: 6px;
    transition:
        border-color 150ms ease,
        background-color 150ms ease;

    /* Tick */
    &::after {
        content: "";
        position: absolute;
        top: 3px;
        left: 6px;
        width: 5px;
        height: 9px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        opacity: 0;
        transform: rotate(45deg);
    }
}

.checkbox:hover .checkbox__mark {
    border-color: var(--custom-color-main-hover, var(--custom-color-main));
}

.checkbox__input:checked + .checkbox__mark {
    border-color: var(--custom-color-main);
    background-color: var(--custom-color-main);

    &::after {
        opacity: 1;
    }
}

.checkbox__input:focus-visible + .checkbox__mark {
    outline: 2px solid var(--custom-color-main);
    outline-offset: 2px;
}

.checkbox__text {
    padding-top: 2px;
    font-size: calc(var(--custom-font-size) * 0.857);
    line-height: 1.333;
}
</style>
